let OtpVerificationResult = /*#__PURE__*/function (OtpVerificationResult) {
  OtpVerificationResult["SENT"] = "sent";
  OtpVerificationResult["BLOCKED"] = "blocked";
  return OtpVerificationResult;
}({});

export { OtpVerificationResult };
//# sourceMappingURL=Otp.js.map
